import Collapse from "@src/components/collapse/Collapse";
import SvgKeyboardArrowDown from "@src/components/icons/KeyboardArrowDown";
import SvgKeyboardArrowUp from "@src/components/icons/KeyboardArrowUp";
import { _Activity } from "@src/Steps/simulate/activities/Activities";
import { useState } from "react";
import "./collapseElement.scss";

type CollapseItem = {
  activity: _Activity;
};

export function CollapseElement({ activity }: CollapseItem) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div className="collapse-element collapse-element__wrapper collapse-element__container">
      <button
        type="button"
        className="collapse-element collapse-element__wrapper-title"
        onClick={() => setIsOpen((prevState) => !prevState)}
        aria-expanded={isOpen}
      >
        <div className="collapse-element__wrapper-title-left">
          <img src={activity.cover} alt={activity.name} />
          <b>{activity.label}</b>
        </div>
        <div className="collapse-element__wrapper-title-color">
          {isOpen ? <SvgKeyboardArrowUp /> : <SvgKeyboardArrowDown />}
        </div>
      </button>
      <Collapse isOpened={isOpen}>
        <div className="collapse-element__modal">
          <div>
            <div className="collapse-element__modal-title">
              <img src="/activities/popover/accident.png" alt={activity.name} />
              <p>Accident</p>
            </div>
            <p>{activity.modal.accident}</p>
          </div>
          <div>
            <div className="collapse-element__modal-title">
              <img src="/activities/popover/blessure.png" alt={activity.name} />
              <p>Blessure</p>
            </div>
            <p>{activity.modal.blessure}</p>
          </div>
          <div>
            <div className="collapse-element__modal-title">
              <img
                src="/activities/popover/indemnisation.png"
                alt={activity.name}
              />
              <p>Indemnisation</p>
            </div>
            <p>{activity.modal.indemnisation}</p>
          </div>
          <small>
            * Prise en charge dès 1 % d&apos;AIPP (Atteinte à l&apos;Intégrité
            Physique et Psychique consolidée)
          </small>
        </div>
      </Collapse>
    </div>
  );
}
